import type { ShareableTemplateFields } from '@/utils/template-share-link';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

const sessionStorageForTemplate = createJSONStorage<ShareableTemplateFields | null>(
  () => sessionStorage
);

const sessionStorageForBoolean = createJSONStorage<boolean>(() => sessionStorage);

/**
 * Stores pending shared template data in sessionStorage.
 * This allows the template data to persist through the auth flow
 * and be imported after signup/login is complete.
 */
export const pendingSharedTemplateAtom = atomWithStorage<ShareableTemplateFields | null>(
  'heidi-pending-shared-template',
  null,
  sessionStorageForTemplate
);

/**
 * Tracks whether a shared template was successfully imported in this session.
 * Used to show the custom template onboarding modal only to users who
 * imported a shared template.
 */
export const hasImportedSharedTemplateAtom = atomWithStorage<boolean>(
  'heidi-has-imported-shared-template',
  false,
  sessionStorageForBoolean
);
